import * as React from 'react'
import * as pdfjsLib from "pdfjs-dist"

declare let pdfMake: any
// declare let pdfjsLib: any

export interface PdfPreviewProps {
	pdf: any
}

export class PdfPreviewState {
	pdf: any
	pdfGenerating: boolean
	pdfGeneratingQueueStatus: boolean
	pdfGeneratingQueueLength: number
}

export class PdfPreview extends React.Component<PdfPreviewProps, PdfPreviewState>{

	private pdfContainerRef: any
	private pdfGeneratingQueueLength: number
	private pdfGenerating: boolean

	constructor(props : PdfPreviewProps){
		super(props)
		this.pdfContainerRef= React.createRef()
		this.state = this.createInitialState()
	}

	createInitialState(): PdfPreviewState{
		return {
			pdf: this.props.pdf,
			pdfGenerating: false,
			pdfGeneratingQueueStatus: false,
			pdfGeneratingQueueLength: 0
		}
	}

	componentDidMount(): void{
		this.generatePdf()
	}

	componentDidUpdate(): void{
		this.generatePdf()
	}

	generatePdf () {
		this.pdfGeneratingQueueLength ++
		if (!this.pdfGenerating) {
			this.pdfGenerating = true
			this.pdfGeneratingQueueLength = 0
			// this.setState({...this.state, pdfGenerating: true})
			// this.state.pdfGenerating = true
			let x = pdfMake.createPdf(this.props.pdf)
			x.getBuffer(this.onPdfGenerated.bind(this))
		}
		else {
			// this.setState({...this.state, pdfGenerating: true})
			// this.state.pdfGeneratingQueueStatus = true
			let me = this
			setTimeout(() => {
				//alert("dodaj")
				if (!me.pdfGenerating && me.pdfGeneratingQueueLength > 0) {
					// this.setState({...this.state, pdfGenerating: false})
					// me.state.pdfGeneratingQueueStatus = false
					me.generatePdf()
				}
			}, 500)
		}
	}

	onPdfGenerated (buff: any) {
		if(this.isArrayBuffer(buff)){
			// Fetch the PDF document from the URL using promises.
			let me = this
			const loadingTask = pdfjsLib.getDocument(buff);
			loadingTask.promise.then((pdf: any) => {
				me.clearPdfCanvasContainer()
				for(let i=1,l=pdf.numPages; i<=l; i++){
					let pageNum = i
					pdf.getPage(i).then((page: any) => {
						me.printPdfPageOnCanvas.apply(me, [page])
					})
				}
				// me.setState({...this.state, pdfGenerating: false})
				// me.state.pdfGenerating = false
				me.pdfGenerating = false
			})
		}
	}

	isArrayBuffer(v: any): boolean{
		return typeof v === 'object' && v !== null && v.byteLength !== undefined
	}

	printPdfPageOnCanvas (page: any) {
		let scale = 1,
			viewport = page.getViewport({scale: scale}),
			canvas: any,
			canvasContainer: any,
			renderContext

		// Prepare canvas using PDF page dimensions.
		canvas = document.createElement('canvas')
		canvas.height = scale * 595 * (297 / 210)
		canvas.width = scale * 595
		canvas.style.border ='5px solid #404040'
		canvas.style.marginLeft = '5px'
		canvas.style.marginRight = '5px'
		canvas.style.marginTop = '5px'
		canvas.style.marginBottom = '5px'

		canvasContainer = this.pdfContainerRef

		if (canvasContainer.current) {
			canvasContainer.current.appendChild(canvas)
		}

		// Render PDF page into canvas context.
		renderContext = {
			canvasContext: canvas.getContext('2d'),
			viewport: viewport
		}
		page.render(renderContext)
	}

	clearPdfCanvasContainer() {
		let canvasContainer: any = this.pdfContainerRef
		if (canvasContainer.current) {
			while (canvasContainer.current.firstChild) {
				canvasContainer.current.removeChild(canvasContainer.current.firstChild)
			}
		}
	}

	render(): React.ReactNode {
		return <div style={{width: '100%',height: '100%', marginLeft: '20px'}}>
			<div ref={this.pdfContainerRef} style={{padding: '5px', width: '100%', overflow: 'auto', margin: "0 auto"}}>Pdf loading</div>
		</div>
	}
}
